import Clipboard from 'clipboard';
const execCopy = (text: string, action: 'cut' | 'copy') => {
    return new Promise((resolve, reject) => {
        const btn = document.createElement('button');
        const cbd = new Clipboard(btn, {
            text: () => {
                return text;
            },
            action: () => {
                return action;
            },
            container: document.body
        });
        cbd.on('success', (e) => {
            cbd.destroy();
            resolve(e);
        });
        cbd.on('error', (e) => {
            cbd.destroy();
            reject(e);
        });
        document.body.appendChild(btn);
        btn.click();
        document.body.removeChild(btn);
    });
};
export default execCopy;
